import { Lock } from '@phosphor-icons/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { CHAT_TYPE } from '../../../../const';
import { useZaraTrial } from '../../../../hooks/useZaraTrial';
import { ADVISOR_LOCK_REASON, getAdvisorLockReason, isPremiumSubscriber } from '../../../../service/advisorAccess';
import { getUser } from '../../../../store/slices/authSlice';
import ImageLoader from '../../ImageLoader';
import MarketPlaceActionButton from '../../MarketplaceActionButton';
import styles from './styles.module.scss';

// HORO-10504: catalog-card CTA copy for each lock reason — see
// `getAdvisorLockReason` for how a card ends up in either state.
const LOCK_CTA_TRANSLATION_KEY = {
    [ADVISOR_LOCK_REASON.REGISTER]: 'buttons.registerToChat',
    [ADVISOR_LOCK_REASON.SUBSCRIBE]: 'buttons.subscribeToChat'
};

const CatalogCard = (props) => {
    const {
        img = '',
        title = '',
        text = '',
        classes = [],
        advisorAlias = '',
        advisorId = '',
        isAllowMulti = false,
        isActivities = false
    } = props;
    const { t } = useTranslation();
    const user = useSelector(getUser);
    const { isExhausted: zaraTrialExhausted } = useZaraTrial();
    const lockReason = getAdvisorLockReason(advisorAlias, {
        isUser: !!user?.id,
        isPremiumUser: isPremiumSubscriber(user),
        zaraTrialExhausted
    });
    const ctaText = lockReason ? t(LOCK_CTA_TRANSLATION_KEY[lockReason]) : undefined;

    return (
        <div className={classNames(styles.card, ...classes)}>
            <div className={styles.image}>
                <ImageLoader src={img} alt={title} loaderSize={64} />
                {lockReason && (
                    <div className={styles.lockBadge}>
                        <Lock size={16} color="#FFFFFF" />
                    </div>
                )}
            </div>
            <div className={styles.column}>
                <h2 className={styles.title}>{title}</h2>
                <div className={styles.text}>{text}</div>
                <MarketPlaceActionButton
                    isActivities={isActivities}
                    advisorId={advisorId}
                    advisorAlias={advisorAlias}
                    text={ctaText}
                    classes={[
                        styles.btn,
                        styles.catalogBtn,
                        !isAllowMulti ? styles.inMultiCard : null,
                        lockReason === ADVISOR_LOCK_REASON.SUBSCRIBE ? styles.subscribeShimmer : null
                    ]}
                />
                {isAllowMulti && (
                    <MarketPlaceActionButton
                        advisorId={advisorId}
                        advisorAlias={advisorAlias}
                        classes={[styles.btn]}
                        chatType={CHAT_TYPE.MULTIPLY}
                        isTransparent={true}
                    />
                )}
            </div>
        </div>
    );
};

export default CatalogCard;
